import React from 'react';
import APIAccessControl from './components/APIAccessControl';

function App() {
  return (
    <div className="App">
      <APIAccessControl />
    </div>
  );
}

export default App;
